 export const makeResetPasswordDTO = (domainName) => ({
  domainName,
});
